import { getRequest } from '@homework-studio/api-client';
import { Config } from '@shared/types';

export const configApi = {
  getList: async () => {
    const res = await getRequest<Config>('/configs');
    return res.data; 
  }, 
};
